module.exports = __webpack_public_path__ + "img/192.f53adafc.jpg";